import { getAllEmailRegexes, updateEmailRegex, addEmailRegex, deleteEmailRegex } from '@/utils/requestHandler.js'
import BadRequest from '@/components/Modal/BadRequestModal/BadRequestModal.vue'
import ConfirmModal from '@/components/Modal/ConfirmModal/ConfirmModal.vue'

export default {
   name: 'EmailWhitelist',
   data() {
      return {
         error: null,
         regexes: [],
         triageRegex: null
      }
   },
   components: {
      BadRequest,
      ConfirmModal
   },
   mounted() {
      getAllEmailRegexes()
         .then(response => {
            response.data.forEach(elem => {
               let original = { regex: elem.regex, activated: elem.activated }
               let changed = { regex: elem.regex, activated: elem.activated }
               this.regexes.push({ original, changed, id: elem.id, new: false })
            })
         })
         .catch(error => {
            this.error = error
         })
   },
   methods: {
      remove(regex) {
         if (regex.new) {
            this.removeRegex(regex)
         } else {
            regex.original.id = regex.id
            deleteEmailRegex(regex.original)
               .then(() => {
                  this.removeRegex(regex)
               })
               .catch(this.displayError)
         }
      },
      confirmDelete(regex) {
         this.triageRegex = regex
      },
      modalCancel() {
         this.triageRegex = null
      },
      modalConfirm() {
         this.remove(this.triageRegex)
         this.triageRegex = null
      },
      displayError(error) {
         console.error(error)
         console.log(error.response)
         this.error = error
      },
      save(regex) {
         if (this.isModified(regex)) {
            if (regex.new) {
               addEmailRegex(regex.changed)
                  .then(response => {
                     regex.id = response.data.id
                     regex.new = false
                     this.updateRegex(regex)
                  })
                  .catch(this.displayError)
            } else {
               regex.changed.id = regex.id
               updateEmailRegex(regex.changed)
                  .then(() => {
                     this.updateRegex(regex)
                  })
                  .catch(this.displayError)
            }
         }
      },
      changeRegex(value, regex) {
         this.findRegex(regex).changed.regex = value
      },
      updateRegex(regex) {
         const regexRef = this.findRegex(regex)
         regexRef.original.regex = regex.changed.regex
         regexRef.original.activated = regex.changed.activated
         regexRef.id = regex.id
         regexRef.new = regex.new
      },
      removeRegex(regex) {
         const index = this.regexes.indexOf(regex)
         this.regexes.splice(index, 1)
      },
      isModified(regex) {
         return regex.changed.regex !== regex.original.regex || regex.changed.activated !== regex.original.activated
      },
      add() {
         let regex = ''
         let activated = false
         this.regexes.push({ changed: { regex, activated }, original: { regex, activated }, new: true })
      },
      findRegex(regex) {
         return this.regexes[this.regexes.indexOf(regex)]
      }
   }
}
